export default "__VITE_ASSET__f11410df__"